import { createSelector } from '@reduxjs/toolkit';
import { StorageState } from '../../../../reducers';

const sliceSelector = (state: StorageState) => state.users.roles.active;

export const accessActiveRoleRulesSelector = () => createSelector(sliceSelector, state => state.accessRules);

export const accessActiveRoleSelector = () => createSelector(sliceSelector, state => state.role);
